<script setup>
import ApplicationLogo from '@/Components/ApplicationLogo.vue';
import { Link } from '@inertiajs/vue3';
import Layout from "@/Layouts/Layout.vue";
</script>

<template>
    <Layout>
        <div class="min-h-screen flex flex-col sm:justify-center items-center pt-6 sm:pt-0 bg-gray-200">
            <div>
                <Link href="/" class="flex flex-row">
                    <div class="">
    <!--                    <ApplicationLogo class="fill-current text-gray-500" />-->
                    </div>
                </Link>
            </div>

            <div
                class="w-full sm:max-w-md mt-6 px-6 py-4 bg-white shadow-md overflow-hidden sm:rounded-sm"
            >
                <slot />
            </div>
        </div>
    </Layout>
</template>
